<div class="page-wrapper">
    <app-header></app-header>

    <!-- Mobile menu toggle button -->
    <!-- <button
        class="mobile-menu-toggle"
        (click)="onToggleMenuSidebar()"
        [attr.aria-label]="'Toggle menu'"
    >
        <i class="fas fa-bars"></i>
    </button> -->

    <app-menu-sidebar
        class="sidebar-dark-primary"
        [class.sidebar-open]="(ui | async)?.menuSidebarCollapsed === false"
    ></app-menu-sidebar>

    <div class="content-wrapper">
        <router-outlet></router-outlet>
    </div>

    <app-task-sidebar
        [class.task-sidebar-open]="(ui | async)?.taskSidebarCollapsed === false"
    ></app-task-sidebar>

    <app-control-sidebar></app-control-sidebar>
    <div
        id="sidebar-overlay"
        class="sidebar-overlay"
        [class.active]="(ui | async)?.menuSidebarCollapsed === false"
        (click)="onToggleMenuSidebar()"
    ></div>
</div>
